"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _list_component = _interopRequireDefault(require("../component/list_component"));

var _data = require("../config/data");

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var MonthPanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MonthPanel, _PureComponent);

  function MonthPanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MonthPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MonthPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterMonth", function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var year = item.year,
          month = item.month;
      var changeHoverDate = _this.props.changeHoverDate;
      changeHoverDate && changeHoverDate(year, month, 0);
    });

    return _this;
  }

  _createClass(MonthPanel, [{
    key: "canUse",
    value: function canUse(theYear) {
      var monthData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = this.props,
          _this$props$optionalS = _this$props.optionalStartDateData,
          optionalStartDateData = _this$props$optionalS === void 0 ? {} : _this$props$optionalS,
          _this$props$optionalE = _this$props.optionalEndDateData,
          optionalEndDateData = _this$props$optionalE === void 0 ? {} : _this$props$optionalE,
          startYear = _this$props.startYear,
          startMonth = _this$props.startMonth,
          shortestRange = _this$props.shortestRange,
          longestRange = _this$props.longestRange,
          _this$props$endData = _this$props.endData,
          endData = _this$props$endData === void 0 ? {} : _this$props$endData,
          _this$props$startData = _this$props.startData,
          startData = _this$props$startData === void 0 ? {} : _this$props$startData,
          endYear = _this$props.endYear,
          endMonth = _this$props.endMonth,
          type = _this$props.type,
          _this$props$hideEndDa = _this$props.hideEndDatePanel,
          hideEndDatePanel = _this$props$hideEndDa === void 0 ? false : _this$props$hideEndDa,
          picker = _this$props.picker;
      var optionalStartYear = optionalStartDateData.year,
          optionalStartMonth = optionalStartDateData.month;
      var optionalEndYear = optionalEndDateData.year,
          optionalEndMonth = optionalEndDateData.month;
      var result = false; // 当前该选项对应月份时间

      var currentMonthTime = new Date(theYear, monthData.value, 1).getTime();
      var startMonthTime = new Date(startData.year, startData.month, 1).getTime(); // 月份范围选择器中可选择的跨度范围

      var canSelectedMonthRangeStartTime = (0, _index.addMonths)(startMonthTime, shortestRange).getTime();
      var canSelectedMonthRangeEndTime = (0, _index.addMonths)(startMonthTime, longestRange).getTime();

      if ((theYear > optionalStartYear || theYear === optionalStartYear && monthData.value >= optionalStartMonth) && (theYear < optionalEndYear || theYear === optionalEndYear && monthData.value <= optionalEndMonth)) {
        result = true;
        var nowYearMonthData = {
          year: theYear,
          month: monthData.value
        };

        if (type === 'start') {
          // 隐藏面板就不需要跟跟结束日期做对比了
          if ((0, _index.compareDate)(nowYearMonthData, {
            year: startYear,
            month: startMonth
          }) > 0 && (0, _index.compareDate)(nowYearMonthData, {
            year: endYear,
            month: endMonth
          }) >= 0 && !hideEndDatePanel && picker === 'date') {
            result = false;
          } else if (!(0, _spauiUtils.isUndefined)(startData.month) && (0, _spauiUtils.isUndefined)(endData.month) && picker === 'month' && !(0, _index.timeInRange)(currentMonthTime, canSelectedMonthRangeStartTime, canSelectedMonthRangeEndTime)) {
            // 如果当前月份不在可选择的跨度范围内
            result = false;
          }
        } else if (type === 'end') {
          if ((0, _index.compareDate)(nowYearMonthData, {
            year: endYear,
            month: endMonth
          }) < 0 && (0, _index.compareDate)(nowYearMonthData, {
            year: startYear,
            month: startMonth
          }) <= 0 && picker === 'date') {
            result = false;
          } else if (!(0, _spauiUtils.isUndefined)(startData.month) && (0, _spauiUtils.isUndefined)(endData.month) && picker === 'month' && !(0, _index.timeInRange)(currentMonthTime, canSelectedMonthRangeStartTime, canSelectedMonthRangeEndTime)) {
            // 如果当前月份不在可选择的跨度范围内
            result = false;
          }
        }
      }

      return result;
    } // 当鼠标 hover 到某一月份

  }, {
    key: "getData",
    value: function getData() {
      var _this2 = this;

      var _this$props2 = this.props,
          year = _this$props2.year,
          _this$props2$optional = _this$props2.optionalStartDateData,
          optionalStartDateData = _this$props2$optional === void 0 ? {} : _this$props2$optional,
          _this$props2$optional2 = _this$props2.optionalEndDateData,
          optionalEndDateData = _this$props2$optional2 === void 0 ? {} : _this$props2$optional2,
          _this$props2$locale = _this$props2.locale,
          locale = _this$props2$locale === void 0 ? {} : _this$props2$locale,
          picker = _this$props2.picker,
          hoverYear = _this$props2.hoverYear,
          hoverMonth = _this$props2.hoverMonth,
          startData = _this$props2.startData,
          endData = _this$props2.endData,
          type = _this$props2.type;
      var optionalStartYear = optionalStartDateData.year;
      var optionalEndYear = optionalEndDateData.year;

      var _ref = startData || {},
          startYear = _ref.year,
          startMonth = _ref.month;

      var _ref2 = endData || {},
          endYear = _ref2.year,
          endMonth = _ref2.month; // 起始月份、截止月份、hover月份的时间戳


      var startMonthTime = 0;
      var endMonthTime = 0;
      var hoverMonthTime = 0;

      if (picker === 'month') {
        if (hoverYear && !(0, _spauiUtils.isUndefined)(hoverMonth)) {
          hoverMonthTime = new Date(hoverYear, hoverMonth).getTime();
        }

        if (startYear && !(0, _spauiUtils.isUndefined)(startMonth)) {
          startMonthTime = new Date(startYear, startMonth).getTime();
        }

        if (endYear && !(0, _spauiUtils.isUndefined)(endMonth)) {
          endMonthTime = new Date(endYear, endMonth).getTime();
        }
      }

      var getLabel = function getLabel(monthNumber) {
        var result = '';
        var month = parseInt(monthNumber, 10) || 0;

        switch (month) {
          case 0:
            result = locale.JanuaryLabel;
            break;

          case 1:
            result = locale.FebruaryLabel;
            break;

          case 2:
            result = locale.MarchLabel;
            break;

          case 3:
            result = locale.AprilLabel;
            break;

          case 4:
            result = locale.MayLabel;
            break;

          case 5:
            result = locale.JuneLabel;
            break;

          case 6:
            result = locale.JulyLabel;
            break;

          case 7:
            result = locale.AugustLabel;
            break;

          case 8:
            result = locale.SeptemberLabel;
            break;

          case 9:
            result = locale.OctoberLabel;
            break;

          case 10:
            result = locale.NovemberLabel;
            break;

          case 11:
            result = locale.DecemberLabel;
            break;
        }

        return result;
      };

      var result = []; // 进行月份筛选 (如果是月份范围选择，还是要显示（有禁止态），避免出现空面板)

      if ((year < optionalStartYear || year > optionalEndYear) && picker === 'date') {
        result = [];
      } else {
        _data.MONTH_LIST.map(function (item) {
          var data = {};

          if (item) {
            data = _objectSpread({}, item, {
              label: getLabel(item.value)
            });

            var canSelect = _this2.canUse(year, item);

            data.disabled = !canSelect; // 如果是月份范围选择

            if (picker === 'month' && (type === 'start' || type === 'end')) {
              var month = data.value;
              var currentMonthTime = new Date(year, month).getTime(); // 添加 hover 的回调函数

              data.onMouseEnter = function () {
                _this2.onMouseEnterMonth({
                  year: year,
                  month: month
                });
              }; // 处于选中月份的中间过程


              if (startMonthTime > 0 && endMonthTime > 0 && currentMonthTime > startMonthTime && currentMonthTime < endMonthTime && canSelect) {
                data.among = true;
              } // 开始或结束月份选中


              if ((year === startYear && month === startMonth || year === endYear && month === endMonth) && canSelect) {
                data.on = true;
              } else {
                data.on = false;
              } // 该月份位于起始月份与鼠标 Hover 的月份中间


              if (canSelect && startYear && !(0, _spauiUtils.isUndefined)(startMonth) && (0, _spauiUtils.isUndefined)(endYear) && (0, _spauiUtils.isUndefined)(endMonth) && (currentMonthTime > startMonthTime && currentMonthTime < hoverMonthTime || currentMonthTime < startMonthTime && currentMonthTime > hoverMonthTime)) {
                data.among = true;
              }
            }

            result.push(data);
          }

          return item;
        });
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          month = _this$props3.month,
          _this$props3$classNam = _this$props3.classNameMap,
          classNameMap = _this$props3$classNam === void 0 ? {} : _this$props3$classNam,
          _this$props3$locale = _this$props3.locale,
          locale = _this$props3$locale === void 0 ? {} : _this$props3$locale,
          setLabel = _this$props3.setLabel;
      return _react["default"].createElement(_list_component["default"], {
        locale: locale,
        setLabel: setLabel,
        classNameMap: classNameMap,
        value: month,
        data: this.getData(),
        onChange: onChange
      });
    }
  }]);

  return MonthPanel;
}(_react.PureComponent);

_defineProperty(MonthPanel, "propTypes", {
  data: _spauiUtils.PropTypes.array,
  year: _spauiUtils.PropTypes.number,
  month: _spauiUtils.PropTypes.number,
  onChange: _spauiUtils.PropTypes.func
});

_defineProperty(MonthPanel, "defaultProps", {
  data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
});

var _default = MonthPanel;
exports["default"] = _default;